import template from './template.html';
import blockBase from "../../mixins/blockBase";
import {includes, remove} from 'lodash';

export default {
    name: 'team',
    template: template,
    mixins: [
        blockBase,
    ],
    data() {
        return {
            active: [0],
        };
    },
    methods: {
        isActive(index) {
            return includes(this.active, index);
        },
        addActiveItem(index) {
            this.$set(this, 'active', [index]);
        },
        triggerItem(index) {
            this.scrollToBox(this.defineTopOffset(this.$refs.mainItem));
            this.addActiveItem(index);
        },
        defineTopOffset(elem) {
            return elem.getBoundingClientRect().top + window.scrollY;
        },
        scrollToBox(top) {
            window.scrollTo({
                top: top,
                behavior: "smooth"
            });
        }
    },
    computed: {
        activeItem() {
            return this.block.team[this.active];
        }
    }
};